import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import Addto from './modal/addto-scheme'; // 新增计算薪资方案
// 接口API 获取方案列表 结算类型列表
import { getList as _getList, getTypeList as _getTypeList, saveProject, delScheme } from '@/api/payroll/salary-scheme';
import Pagination from '../../../components/pagination';
export default {
  components: {
    Addto: Addto,
    Pagination: Pagination
  },
  data: function data() {
    return {
      show: {
        addVisible: false // 新增弹窗
      },

      tableData: [],
      // 表格数据
      // 分页相关
      page: {
        page: 1,
        // 当前页
        total: 0,
        // 总条数
        limit: 20
      },
      typeList: [],
      // 结算类型
      csrf_token: '',
      currentData: {} // 当前选中项
    };
  },
  created: function created() {
    this.init();
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    contentViewHeight: function contentViewHeight(state) {
      return state.settings.contentViewHeight;
    }
  })), {}, {
    tableHeight: function tableHeight() {
      return this.contentViewHeight - 104;
    }
  }),
  methods: {
    init: function init() {
      this.getList();
      this.getTypeList();
    },
    getTypeList: function getTypeList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _getTypeList();
            case 2:
              res = _context.sent;
              data = res.data;
              _this.typeList = data.type_list;
              _this.csrf_token = data.csrf_token;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 渲染名称
    showName: function showName(row) {
      if (row.isShow === undefined) row.isShow = false;
      return row.name;
    },
    // 新增方案
    handlerCreate: function handlerCreate(params) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var msg, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              msg = _objectSpread(_objectSpread({}, params), {}, {
                csrf_token: _this2.csrf_token
              });
              _context2.next = 3;
              return saveProject(msg);
            case 3:
              res = _context2.sent;
              _this2.show.addVisible = false;
              if (res && res.code === 1) {
                _this2.$router.push({
                  path: '/payroll/salary-edit/' + res.data.payroll_sub_project_scheme_id,
                  query: {
                    type: String(params.type)
                  }
                });
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 获取列表
    getList: function getList() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res, data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _getList(_this3.page);
            case 2:
              res = _context3.sent;
              data = res.data; // 表格数据
              _this3.tableData = Array.isArray(data.list) && data.list.map(function (item) {
                item.isShow = false;
                return item;
              });
              // 分页总条数
              _this3.$set(_this3.page, 'total', data.count);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 过滤列表数据获取方案名称
    getMapresult: function getMapresult(key) {
      key = Number(key);
      if (!this.typeList) return '';
      var res = this.typeList.filter(function (item) {
        return item.key = key;
      });
      return res && res[0] && res[0].txt;
    },
    // 删除方案
    handleDel: function handleDel(row, index) {
      var _this4 = this;
      var $t = this.$t;
      this.$confirm($t('1147'), $t('229'), {
        confirmButtonText: $t('131'),
        cancelButtonText: $t('66'),
        type: 'warning'
      }).then(function () {
        delScheme(row).then(function () {
          _this4.tableData.splice(index, 1);
        });
      });
    },
    // 编辑名称
    changeEdit: function changeEdit(row, state, status) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this5.$set(row, 'isShow', state || false);
              // 如果status为真 则修改名称
              if (status) {
                saveProject(_objectSpread(_objectSpread({}, row), {}, {
                  csrf_token: _this5.csrf_token
                })).then(function (res) {
                  _this5.csrf_token = res.data.csrf_token;
                }).finally(function (res) {
                  _this5.getList();
                });
              }
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    // 表格项编辑按钮
    handlerEdit: function handlerEdit(row) {
      this.$router.push({
        path: '/payroll/salary-edit/' + row.payroll_sub_project_scheme_id,
        query: {
          type: row.type
        }
      });
      this.currentData = row;
    },
    // open or close modal
    open: function open(key, value) {
      var _this6 = this;
      // 每次打开重新请求列表类型
      if (key === 'addVisible') {
        this.getTypeList();
        this.$nextTick(function () {
          _this6.$set(_this6.show, key, value);
        });
        return;
      }
      this.$set(this.show, key, value);
    },
    // 分页触发
    currentChangeHandle: function currentChangeHandle(val) {
      this.page.page = val;
      this.getList();
    }
  }
};